<template>
  <div>
    <div
      class="progress-indicator"
      :class="'status-' + status"
    >
      <div class="icon el-icon-upload"></div>

      <transition name="fade" mode="out-in">
        <div v-if="status !== 'nothing'"
          class="icon--text">
          <div v-if="progress < 1">
            {{ progress | toPercentage }}
          </div>
          <div v-else>
            <i class="icon--inner el-icon-check"></i>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      default: 'nothing',
    },
  },
  filters: {
    toPercentage(value) {
      return `${(value * 100).toFixed(1)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
$upload-bg-color: #2c3e50; // TODO: grab this from the variables
$upload-color: #ffffff;

.progress-indicator,
.progress-indicator__text {
  text-align: center;
}
.progress-indicator {
  position: relative;
  .icon {
    position: relative;
    font-size: 10em;
    color: $upload-bg-color;
  }
  .icon--text {
    height: 2.4em;
    width: 3em;
    color: $upload-color;
    font-size: 2em;

    // Centralise inner text
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    margin-bottom: 2em;
    position: absolute;

    // Centralise overral
    top: -50%;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(50%);
  }
  .icon--inner {
    font-size: 1.6em;
    font-weight: bold;
  }
}
.progress-indicator {
  .icon::after {
    content: '';
    height: 60%;
    width: 36%;
    background: $upload-bg-color;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    margin: auto;
  }
}

// Transitions
.progress-indicator {
  $transition-duration: .5s;

  .icon::after {
    opacity: 1;
    transition: opacity $transition-duration;
  }
  &.status-nothing .icon::after {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity $transition-duration;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/VideoUpload/ProgressIndicator.vue